// Пауза до автооткрытия чата: владелец задаёт её в кабинете, конфиг виджета
// привозит СЕКУНДЫ (Assistants::WidgetSettings#auto_open_delay). Чистый модуль
// (DOM нет) — тестируется в изоляции (delay.test.mjs), как receipt.ts.

/** Фолбэк, когда конфиг не отдал число: 60 с — тот же дефолт, что на сервере
 *  (Assistants::WidgetSettings::DEFAULT_DELAY). Пауза была жёстко зашитой (15 с),
 *  потом настройкой с дефолтом 20; 30 — решение владельца 10.09.2026. */
const DEFAULT_DELAY_S = 60;
// Верхняя граница — зеркало серверной (DELAY_RANGE): больше пяти минут —
// визит уже закончился, и настройка выглядит поломкой.
//
// Нижняя НЕ зеркалит серверные 30 секунд. Решает сервер: клиентскому сайту он
// и так не отдаёт меньше тридцати (поп-ап в лицо гостю, который ещё читает
// первый экран), а холодному демо отдаёт три — его открывают РОВНО ради
// сотрудника. Зеркало границы здесь было ловушкой: 11.09.2026 серверную паузу
// демо починили, конфиг привозил 3, а виджет читал тройку как «вне границ» и
// ждал минуту — чат снова не открывался (поймано владельцем на живой ссылке).
// Здесь остаётся защита от мусора и бессмыслицы: ноль, отрицательное, вечность.
const MIN_DELAY_S = 1;
const MAX_DELAY_S = 300;

/** Пауза до автооткрытия в миллисекундах.
 *
 *  Сервер границы уже держит, но виджет живёт на чужих сайтах и кешируется:
 *  старый widget.js встречает новый конфиг и наоборот. Поэтому всё, что не целое
 *  число секунд в границах (поля нет, null, строка, NaN, отрицательное, вечность),
 *  читается дефолтом — виджет не ломается ни при каком конфиге.
 *
 *  @param seconds значение auto_open_delay из конфига.
 *  @return задержка в мс, всегда в границах [MIN, MAX]. */
export function autoOpenDelayMs(seconds: unknown): number {
  const value = typeof seconds === 'number' ? Math.round(seconds) : NaN;
  const valid = value >= MIN_DELAY_S && value <= MAX_DELAY_S;
  return (valid ? value : DEFAULT_DELAY_S) * 1000;
}
